if (!window.dutKitEntryBound) {
  window.dutKitEntryBound = true;
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-kit-entry]');
    if (!link) return;
    event.preventDefault();
    if (link.dataset.busy) return;
    const form = document.getElementById(link.dataset.form);
    const url = new URL(link.href);
    const variant = form?.querySelector('[name="id"]')?.value || url.searchParams.get('variant');
    if (!variant) return;
    const data = form ? new FormData(form) : new FormData();
    data.set('id', variant);
    if (!data.has('quantity')) data.set('quantity', '1');
    data.delete('sections');
    const label = link.innerHTML;
    link.dataset.busy = 'true';
    link.setAttribute('aria-busy', 'true');
    link.textContent = 'Adding to cart…';
    let message = link.parentElement.querySelector('[data-kit-entry-status]');
    if (!message) { message = document.createElement('p'); message.dataset.kitEntryStatus = ''; message.setAttribute('role', 'status'); link.after(message); }
    message.textContent = '';
    message.hidden = true;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Could not add this product. Please try again.');
      url.searchParams.set('variant', variant);
      url.searchParams.set('cart_variant', variant);
      window.location.assign(url.href);
    } catch (error) {
      message.hidden = false;
      message.textContent = error.message || 'Could not confirm the cart update. Check your cart before trying again.';
      delete link.dataset.busy;
      link.removeAttribute('aria-busy');
      link.innerHTML = label;
    }
  });
}
